module.exports = "/images/vendor/jquery-ui/themes/base/ui-icons_555555_256x240.png?91b1966e761a8e0c0b83450f676e8fe4";